import {
    QuestionProps,
    QuestionStatus,
} from '../../../interfaces/questions.interface';
import { getSrc } from '../../../../../utils/common/getSrc';

export const preparePayload = (values: QuestionProps) => {
    const payload = {
        knowledge_id: values.knowledge_id,
        question_status: QuestionStatus.PUBLISHED,
        category_id: values.category_id,
        question_text: values.question_text,
        answer_text: values.answer_text,
        question_image: values.question_image as File,
        answer_image: values.answer_image as File,
    };

    if (!(values.question_image instanceof File)) {
        delete payload.question_image;
    }
    if (!(values.answer_image instanceof File)) {
        delete payload.answer_image;
    }
    if (!values.category_id) {
        delete payload.category_id;
    }

    return payload;
};
export const mapQuestionToFormValues = (
    question: QuestionProps
): QuestionProps => ({
    ...question,
    question_status: question.status,
    question_text: question.context,
    question_image: getSrc(question?.image),
    answer_text: question.answer.context,
    answer_image: getSrc(question.answer?.image),
});
